const POLL_INTERVAL_MS = 200;
const MAX_ATTEMPTS = 30;

/**
 * Scrolls to and highlights the element named by the URL hash (e.g. `#rating-12`) when the hash
 * starts with the given prefix. Polls briefly because the target may render after Livewire boots.
 *
 * @param {{ prefix: string, highlightClass: string }} config
 */
export default function hashHighlight({ prefix, highlightClass }) {
    let interval = null;

    return {
        init() {
            const hash = window.location.hash;

            if (!hash.startsWith(`#${prefix}`)) {
                return;
            }

            const targetId = hash.substring(1);

            if (this.highlight(targetId)) {
                return;
            }

            let attempts = 0;
            interval = setInterval(() => {
                attempts++;

                if (this.highlight(targetId) || attempts > MAX_ATTEMPTS) {
                    clearInterval(interval);
                }
            }, POLL_INTERVAL_MS);
        },

        destroy() {
            clearInterval(interval);
        },

        highlight(targetId) {
            const element = document.getElementById(targetId);

            if (!element) {
                return false;
            }

            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.classList.add(highlightClass);

            return true;
        },
    };
}
